import {Service} from "../Service";
import miniToastr from "mini-toastr";

export class MovimientoService extends Service {


    constructor() {
        super('movimiento/');
        this.fieldsMovimientoPorEstatus = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombrePaciente', label: 'Paciente', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'diasSolucion', label: 'Dias para solucionar'},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'folioPolizaContableErp',
                label: 'Folio poliza',
                sortable: true,
                formatter: (v) => this.formatters.string.validarObjetoVacio(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {
                key: 'monto',
                label: 'Monto',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {key: 'autorizaciones', label: 'Autorizaciones'},
            {key: 'detalle', label: 'Detalle'},
            {key: 'archivos', label: 'Archivos'},
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},
        ]
        if (this.localStorage.can('MV_ch_estatus_aceptado')) {
            this.fieldsMovimientoPorEstatus.push({key: 'aceptarMovimiento', label: 'Aceptar'});

        }
        if (this.localStorage.can('MV_ch_estatus_rechazado')) {
            this.fieldsMovimientoPorEstatus.push({key: 'rechazarMovimiento', label: 'Rechazar'});
        }

        this.fieldsCashbackPorEstatus = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombrePaciente', label: 'Paciente', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'diasSolucion', label: 'Dias para solucionar'},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'folioPolizaContableErp',
                label: 'Folio poliza',
                sortable: true,
                formatter: (v) => this.formatters.string.validarObjetoVacio(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {
                key: 'monto',
                label: 'Monto',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {key: 'detalle', label: 'Detalle'},
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},

        ]

        if (this.localStorage.can('MV_ch_estatus_aceptado')) {
            this.fieldsCashbackPorEstatus.push({key: 'aceptarMovimiento', label: 'Aceptar'});

        }
        if (this.localStorage.can('MV_ch_estatus_rechazado')) {
            this.fieldsCashbackPorEstatus.push({key: 'rechazarMovimiento', label: 'Rechazar'});
        }

        this.fieldsMovimientoPorPaciente = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombreStatus', label: 'Estatus', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'diasSolucion', label: 'Dias para solucionar', sortable: true},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'monto',
                label: 'Monto',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},
        ];

        this.fieldsMovimientoTodosAceptados = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombreStatus', label: 'Estatus', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'monto',
                label: 'Monto',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {key: 'totalSaldoFechaSolucion', label: 'Saldo fecha solucion'},
            {key: 'pdf', label: 'Comprobante'},

        ];
        this.fieldsMovimientoDetalle = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombreStatus', label: 'Estatus', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'monto',
                label: 'Monto',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {key: 'saldoTotal', label: 'Saldo Total'},

        ];

        this.fieldsTraspasoPorEstatus = [
            {key: 'folio', label: 'Folio', sortable: true},
            {key: 'area', label: 'Área', sortable: true},
            {key: 'clinica', label: 'Clínica', sortable: true},
            {key: 'empleado', label: 'Empleado', sortable: true},
            {key: 'pacienteOrigen', label: 'Paciente origen', sortable: true},
            {key: 'pacienteDestino', label: 'Paciente destino', sortable: true},
            {key: 'tipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'diasSolucion', label: 'Dias para solucionar'},
            {key: 'folioPolizaContableErp', label: 'Folio poliza', sortable: true},
            {key: 'monto', label: 'Monto', sortable: true},
            {key: 'autorizaciones', label: 'Autorizaciones', sortable: true},
            {key: 'Detalle', label: 'Detalle', sortable: true},
            {key: 'archivos', label: 'Archivos'},
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},

        ];

        if (this.localStorage.can('MV_ch_estatus_aceptado')) {
            this.fieldsTraspasoPorEstatus.push({key: 'aceptarMovimiento', label: 'Aceptar'});
        }
        if (this.localStorage.can('MV_ch_estatus_rechazado')) {
            this.fieldsTraspasoPorEstatus.push({key: 'rechazarMovimiento', label: 'Rechazar'});
        }

        this.fieldsTraspasoPorPaciente = [
            {key: 'folio', label: 'Folio', sortable: true},
            {key: 'estatus', label: 'Estatus', sortable: true},
            {key: 'area', label: 'Área', sortable: true},
            {key: 'clinica', label: 'Clínica', sortable: true},
            {key: 'empleado', label: 'Empleado', sortable: true},
            {key: 'pacienteOrigen', label: 'Paciente origen', sortable: true},
            {key: 'pacienteDestino', label: 'Paciente destino', sortable: true},
            {key: 'tipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'folioPolizaContableErp', label: 'Folio poliza', sortable: true},
            {key: 'monto', label: 'Monto', sortable: true},
            {key: 'Detalle', label: 'Detalle', sortable: true},
            {key: 'archivos', label: 'Archivos'},
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},
        ];

        this.fieldsReembolsoPorEstatus = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombrePaciente', label: 'Paciente', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'diasSolucion', label: 'Dias para solucionar', sortable: true},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'folioPolizaContableErp',
                label: 'Folio poliza',
                sortable: true,
                formatter: (v) => this.formatters.string.validarObjetoVacio(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {
                key: 'monto',
                label: 'Monto Solicitado',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {
                key: 'montoReembolsado',
                label: 'Monto a reembolsar',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {key: 'autorizaciones', label: 'Autorizaciones'},
            {key: 'detalle', label: 'Detalle'},
            {key: 'archivos', label: 'Archivos'},
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},
        ]
        if (this.localStorage.can('RE_nota_credito')) {
            this.fieldsReembolsoPorEstatus.push({key: 'notaCredito', label: 'Nota de Crédito'});

        }
        if (this.localStorage.can('MV_ch_estatus_aceptado')) {
            this.fieldsReembolsoPorEstatus.push({key: 'aceptarMovimiento', label: 'Aceptar'});

        }
        if (this.localStorage.can('MV_ch_estatus_rechazado')) {
            this.fieldsReembolsoPorEstatus.push({key: 'rechazarMovimiento', label: 'Rechazar'});
        }


        this.fieldsReembolsoPorPaciente = [
            {key: 'idMovimiento', label: 'Folio', sortable: true},
            {key: 'nombreArea', label: 'Área', sortable: true},
            {key: 'nombreClinica', label: 'Clínica', sortable: true},
            {key: 'nombreEmpleado', label: 'Empleado', sortable: true},
            {key: 'nombreStatus', label: 'Estatus', sortable: true},
            {key: 'nombreTipoMovimiento', label: 'Tipo', sortable: true},
            {key: 'diasSolucion', label: 'Dias para solucionar', sortable: true},
            {
                key: 'fechaAlta',
                label: 'Fecha solicitud',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'fechaSolucion',
                label: 'Fecha solucion',
                formatter: (v) => this.formatters.date.dataTimeToLocalString(v)
            },
            {
                key: 'monto',
                label: 'Monto Solicitado',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {
                key: 'montoReembolsado',
                label: 'Monto a reembolsar',
                sortable: true,
                formatter: (v) => this.formatters.number.moneda(v)
            },
            {
                key: 'aFavor',
                label: 'A favor/En contra',
                sortable: true,
                formatter: (v) => this.formatters.boolean.aFavorEnContra(v)
            },
            {key: 'saldoTotal', label: 'Saldo Total'},
            {key: 'pdf', label: 'Comprobante'},
        ];


    }


    getPdfMovimiento(idMovimiento){
        this.onStart();
        return this.http.get(this.getUrl(['pdf','movimiento'],{idMovimiento}))
            .then(r=> this.onData(r))
            .then(r=> this.onData(r))
            .then( data => {
                return 'data:application/pdf;base64,'+data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    getPdfTransferencia(idMovimiento){
        this.onStart();
        return this.http.get(this.getUrl(['pdf','transferencia'],{idMovimiento}))
            .then(r=> this.onData(r))
            .then(r=> this.onData(r))
            .then( data => {
                return 'data:application/pdf;base64,'+data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    puedeVerListaMovimiento(tipoMovimiento) {
        switch (tipoMovimiento) {
            case 1: {
                return this.localStorage.can('MV_ls_estatus_abierto')
            }
            case 2: {
                return this.localStorage.can('MV_ls_estatus_en_proceso')
            }
            case 3: {
                return this.localStorage.can('MV_ls_estatus_cancelado')
            }
            case 4: {
                return this.localStorage.can('MV_ls_estatus_rechazado')
            }
            case 5: {
                return this.localStorage.can('MV_ls_estatus_aceptado')
            }
            case 6: {
                return this.localStorage.can('MV_ls_estatus_revision')
            }
            default: {
                return false;
            }
        }

    }
    puedeVerListaCashBack(tipoMovimiento) {
        switch (tipoMovimiento) {
            case 1: {
                return this.localStorage.can('CB_ls_estatus_abierto')
            }
            case 2: {
                return this.localStorage.can('CB_ls_estatus_en_proceso')
            }
            case 3: {
                return this.localStorage.can('CB_ls_estatus_cancelado')
            }
            case 4: {
                return this.localStorage.can('CB_ls_estatus_rechazado')
            }
            case 5: {
                return this.localStorage.can('CB_ls_estatus_aceptado')
            }
            case 6: {
                return this.localStorage.can('CB_ls_estatus_revision')
            }
            default: {
                return false;
            }
        }

    }

    puedeVerListaTransferencia(tipoMovimiento) {
        switch (tipoMovimiento) {
            case 1: {
                return this.localStorage.can('TR_ls_estatus_abierto')
            }
            case 2: {
                return this.localStorage.can('TR_ls_estatus_en_proceso')
            }
            case 3: {
                return this.localStorage.can('TR_ls_estatus_cancelado')
            }
            case 4: {
                return this.localStorage.can('TR_ls_estatus_rechazado')
            }
            case 5: {
                return this.localStorage.can('TR_ls_estatus_aceptado')
            }
            case 6: {
                return this.localStorage.can('TR_ls_estatus_revision')
            }
            default: {
                return false;
            }
        }

    }

    puedeVerListaReembolsos(tipoMovimiento) {
        switch (tipoMovimiento) {
            case 1: {
                return this.localStorage.can('RE_ls_estatus_abierto')
            }
            case 2: {
                return this.localStorage.can('RE_ls_estatus_en_proceso')
            }
            case 3: {
                return this.localStorage.can('RE_ls_estatus_cancelado')
            }
            case 4: {
                return this.localStorage.can('RE_ls_estatus_rechazado')
            }
            case 5: {
                return this.localStorage.can('RE_ls_estatus_aceptado')
            }
            case 6: {
                return this.localStorage.can('RE_ls_estatus_revision')
            }
            default: {
                return false;
            }
        }

    }



    autorizarMovimiento(idMovimiento, idEmpleado) {
        return this.http.post(this.getUrl(['autorizarMovimiento'], {idMovimiento, idEmpleado}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then((r) => {
                miniToastr.info('Se ha guardado correctamente')
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    autorizarTraspaso({origen}, idEmpleado) {
        this.autorizarMovimiento(origen.idMovimiento, idEmpleado).then(() => {
            this.toast.info('Transferencia autorizada')
        })
    }

    cambiarTraspasoEstatusCancelado({origen}) {
        return this.cambiarEstatusCancelado(origen.idMovimiento).then(() => {
            this.toast.info('Transferencia cancelada')

        })
    }

    cambiarTraspasoEstatusAceptado({origen}) {
        return this.cambiarEstatusAceptado(origen.idMovimiento).then(() => {
            this.toast.info('Transferencia Aceptada')
        })
    }

    cambiarTraspasoEstatusRechazado({origen}) {
        return this.cambiarEstatusRechazado(origen.idMovimiento).then(() => {
            this.toast.info('Transferencia Rechazada')
        })
    }

    cambiarEstatusAbierto(idMovimiento) {
        this.onStart();
        return this.cambiarEstatus(idMovimiento, 'abierto');
    }

    cambiarEstatusEnProceso(idMovimiento) {
        return this.cambiarEstatus(idMovimiento, 'enProceso');

    }

    cambiarEstatusCancelado(idMovimiento) {
        return this.cambiarEstatus(idMovimiento, 'cancelado');

    }

    cambiarEstatusCanceladoConComentario(idMovimiento, idEmpleado, comentario) {
        return this.cambiarEstatusConComentario(idMovimiento, idEmpleado, comentario, 'cancelado');

    }

    cambiarEstatusRechazado(idMovimiento) {
        return this.cambiarEstatus(idMovimiento, 'rechazado');

    }

    cambiarEstatusAceptado(idMovimiento) {
        return this.cambiarEstatus(idMovimiento, 'aceptado');
    }

    cambiarEstatusRevision(idMovimiento) {
        return this.cambiarEstatus(idMovimiento, 'revision');
    }

    cambiarEstatus(idMovimiento, estatus) {
        return this.http.post(this.getUrl(['estatus', estatus], {idMovimiento}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then((r) => {
                miniToastr.info('Se ha guardado correctamente')
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    cambiarEstatusConComentario(idMovimiento, idEmpleado, comentario, estatus) {
        return this.http.post(this.getUrl(['estatus','comentario', estatus], {idMovimiento, idEmpleado, comentario}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then((r) => {
                miniToastr.info('Se ha guardado correctamente')
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarMovimientos(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.get(this.getUrl(['listar', 'movimientos', url], params), config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarMovimientosFecha(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.post(this.getUrl(['fecha', 'listar', 'movimientos', url]), params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarMovimientosClinicas(params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['listar', 'movimientos', 'clinicas']), params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarMovimientosTodosAceptados(params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['listar', 'movimientos', 'todos', 'aceptados']),params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarCashBack(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.get(this.getUrl(['listar', 'cashback', url], params), config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarCashBackFecha(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.post(this.getUrl(['fecha', 'listar', 'cashback', url]), params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarCashbackClinicas(params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['listar', 'cashback', 'clinicas']), params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarTraspasos(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.get(this.getUrl(['listar', 'traspasos', url], params), config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarTraspasosFecha(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.post(this.getUrl(['fecha', 'listar', 'traspasos', url]), params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    listarTraspasosClinicas(params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['listar', 'traspasos', 'clinicas']), params, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerBalance(params, config) {
        this.onStart();
        return this.http.get(this.getUrl(['balance'], params), config)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    crearTraspaso(traspaso)     {
        this.onStart();
        return this.http.post(this.getUrl(['guardar', 'traspaso']), traspaso)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then(r => {
                this.toast.info("Datos guardados con exito")
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    crearCashback(cashback) {
        this.onStart();
        const url = cashback.aFavor === true ? 'afavor' : 'enContra';
        return this.http.post(this.getUrl(['guardar', 'cashback', url]), cashback)
            .then((response) => {
                this.toast.info("Datos guardados con exito")
                return this.onData(response)
            })
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    crearReembolso(reembolso)     {
        this.onStart();
        return this.http.post(this.getUrl(['guardar', 'reembolso']), reembolso)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then(r => {
                this.toast.info("Datos guardados con exito")
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    listarReembolsos(params, config) {
        this.onStart();
        const url = params.idPaciente ? 'paciente' : 'estatus';
        return this.http.get(this.getUrl(['listar', 'reembolsos', url], params), config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerUrlMovimiento() {
        this.onStart();
        return this.http.get(this.getUrl(['url', 'movimiento']))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarArchivos(idMovimiento, archivos) {
        return this.http.post(this.getUrl(['guardar', 'archivos'], {idMovimiento, archivos }))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then((r) => {
                miniToastr.info('Se ha guardado correctamente')
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

}
